import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Product';

const ProductApi: any = baseApi(endpoint);

export default ProductApi;